//GroupStudyHome.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';

import Tooltip from '../../components/utils/Tooltip';
import './styles/GroupStudy.css';
import './styles/BookShelf.css';
import groupstudyimage from '../../assets/pageimages/GroupStudy.webp';

import adImage from '../../assets/pageimages/bookworldlistad.webp';


const GroupStudyHome = () => {
    const tooltiptext = "About Think5Whys";

    return (
        <MainLayout>
            <div>
                <h3 className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>Learnings - Group Study</h3>
            </div>
            <div className="bookshelf-container w-7/12">
                <div className='relative inset-0 flex justify-center mt-2 mb-2'>
                    <img src={adImage} />
                </div>
                <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
                    <div className="button-links flex align-middle justify-center bg-gray-500">
                        <div className="bottom-buttons-box"><Link to="/groupstudy-library" className="top-button-link"><FontAwesomeIcon icon={faSchoolCircleCheck} className="groupstudy-bottomlink-style" />My Groups</Link></div>
                        <div className="bottom-buttons-box"><Link to="/groupstudy-artbook" className="top-button-link"><FontAwesomeIcon icon={faBookAtlas} className="groupstudy-bottomlink-style" />My Group Books</Link></div>
                        <div className="bottom-buttons-box"><Link to="/groupstudy-create-master" className="top-button-link"><FontAwesomeIcon icon={faPlusSquare} className="groupstudy-bottomlink-style" />Group Notes</Link></div>
                        <div className="bottom-buttons-box"><Link to="/groupstudy-changes" className="top-button-link"><FontAwesomeIcon icon={faEdit} className="groupstudy-bottomlink-style" />Group Read History</Link></div>
                        <div className="bottom-buttons-box"><Link to="/groupstudy-comments" className="top-button-link"><FontAwesomeIcon icon={faComment} className="groupstudy-bottomlink-style" />Group Practice Test</Link></div>
                        <div className="bottom-buttons-box"><Link to="/groupstudy-followups" className="top-button-link"><FontAwesomeIcon icon={faRedo} className="groupstudy-bottomlink-style" />Group Content Links</Link></div>
                        <div className="bottom-buttons-box"><Link to="/groupstudy-mentors" className="top-button-link"><FontAwesomeIcon icon={faComment} className="groupstudy-bottomlink-style" />Our Mentors</Link></div>
                        <div className="bottom-buttons-box"><Link to="/groupstudy-chathistory" className="top-button-link"><FontAwesomeIcon icon={faRedo} className="groupstudy-bottomlink-style" />Group Chats</Link></div>
                    </div>
                </div>
                <div className="relative inset-0 flex border border-b-gray-300">
                    <img id="groupstudy-id" src={groupstudyimage} alt="Group Study Image" />
                </div>
            </div>
        </MainLayout>
    );
};

export default GroupStudyHome;
